export const simpleEncrypt = str =>
  str
    .split('')
    .map(c => String(c.charCodeAt(0)).padStart(3, '0'))
    .join('')
